import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import { CompetenceProvider } from "../../../shared/providers/enums/billing-letter/competence-provider";
import { PurchaseOrderService } from '../../../services/purchaseOrder.service';
import { ProductService } from '../../../services/product.service';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { UserService } from '../../../services/user.service';
import { CompaniesService } from '../../../services/companies.service';
import { ConsultantService } from '../../../services/consultant.service';
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { PurchaseOrder } from '../../../models/PurchaseOrder.model';
import { Approver } from '../../../models/Approver.model';
import { Responsible } from '../../../models/Responsible.model';
import { Company } from '../../../models/Company.model';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { DropDownList } from '../../../models/DropDownList.model';
import * as _ from 'lodash';
import { ExcellenceCentersService } from "../../../services/excellenceCenters.service";
import { ExcellenceCenter } from "../../../models/ExcellenceCenter.model";
@Component({
    selector: 'app-purchase-order-hierarchy',
    templateUrl: './purchase-order-hierarchy.component.html',
    styleUrls: ['./purchase-order-hierarchy.component.css']
})
export class PurchaseOrderHierarchyComponent implements OnInit {
    @ViewChild("buttonModalHierarchy") buttonModalHierarchy: ElementRef;
    @ViewChild("closeModal") closeModal: ElementRef;
    loading: boolean;
    loggedUser;
    commonHelper: CommonHelper = new CommonHelper();
    users: Responsible[] = new Array<Responsible>();
    excellenceCenters: Array<ExcellenceCenter> = [];
    allCenters: Array<ExcellenceCenter> = [];
    hasRequiredExcellenceCenter: boolean = false;
    valueAux: number = 0;
    userAux = {
        _id: '',
        name: '',
        maxValue: 0
    };

    excellenceCenterAuxId: ''

    managerApprovalValue: number = 0;
    purchaseOrderHierarchy = {
        _id: '',
        manager: {},
        hierarchy: [],
        excellenceCenterId: ''
    }
    editing: number = -1


    constructor(
        private localStorage: LocalStorage,
        private router: Router,
        public toastr: ToastsManager,
        public userService: UserService,
        private excellenceCentersService: ExcellenceCentersService,
        public purchaseOrderService: PurchaseOrderService
    ) { }

    async ngOnInit() {
        this.loading = true;
        this.loggedUser = this.localStorage.retrieve('user');
        this.users = await this.userService.getUsersByType([
            'manager', 'governance', 'commercial', 'administrative', 'finances', 'bills-receive', 'dp', 'people'
        ]);

        const purchaseOrderHierarchy = await this.purchaseOrderService.getPurchaseOrderHierarchy(this.loggedUser.username);
        if(purchaseOrderHierarchy) {
            this.purchaseOrderHierarchy = purchaseOrderHierarchy;
            if(this.purchaseOrderHierarchy.hierarchy && this.purchaseOrderHierarchy.hierarchy.length > 0) {
                this.managerApprovalValue = this.purchaseOrderHierarchy.hierarchy[this.purchaseOrderHierarchy.hierarchy.length-1].maxValue;
            }
        } else {
            this.purchaseOrderHierarchy.manager = {
                name: this.loggedUser.name,
                email: this.loggedUser.username,
                division: this.loggedUser.division
            }
        }
        this.allCenters = await this.excellenceCentersService.getAll();

        this.excellenceCenters = this.allCenters.filter(center => center.type == 1 );
        this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

        this.loading = false;
    }

    async OnSave() {
        try {
            this.loading = true;
            let response = await this.purchaseOrderService.savePurchaseOrderHierarchy(this.purchaseOrderHierarchy);
            if(response._id){
                this.toastr.success('Alçada salva com sucesso');
                await this.purchaseOrderService.updateManager(this.loggedUser.username)
            }
            else
                this.toastr.warning('Erro ao salvar alçada');
            this.loading = false;
            this.router.navigate(['/purchase-orders']);
        } catch(err) {
            this.loading = false;
            this.toastr.warning('Erro ao salvar alçada');
            console.log(err);
        }
    }

    OnClear(){
        this.userAux = { _id: '', name: '', maxValue: 0 };
    }

    addUserHierarchy() {
        if (this.editing > -1) {
            const user = this.users.find(u => u._id === this.userAux._id);
            this.purchaseOrderHierarchy.hierarchy[this.editing] = {
                _id: user._id,
                name: user.name,
                maxValue: this.userAux.maxValue,
                excellenceCenterId: this.excellenceCenterAuxId
            }
            return;
        }

        if(this.purchaseOrderHierarchy.hierarchy.length > 0){
            const existApproverWithValue = this.purchaseOrderHierarchy.hierarchy.find(h => h.maxValue == this.userAux.maxValue);
            if(existApproverWithValue) {
                this.toastr.warning('Esta alçada não pode ser adicionada, valor de aprovação já existe na listagem de alçada', 'Operação inválida'); return;
            }

            const ids = this.purchaseOrderHierarchy.hierarchy.map((approver) => approver.excellenceCenterId);

            if (ids.includes(this.excellenceCenterAuxId)) {
                this.toastr.warning('Você não pode ter dois usuarios no mesmo centro de excelencia')
                return;
            }
        }

        const user = this.users.find(u => u._id === this.userAux._id);
        // add exellenceCenter
        this.purchaseOrderHierarchy.hierarchy.push({
            _id: user._id,
            name: user.name,
            maxValue: this.userAux.maxValue,
            excellenceCenterId: this.excellenceCenterAuxId
        });

        this.sortHierarchy();
        // add exellenceCenter
        this.userAux = { _id: '', name: '', maxValue: 0};
        this.managerApprovalValue = this.purchaseOrderHierarchy.hierarchy[this.purchaseOrderHierarchy.hierarchy.length-1].maxValue;
        this.closeModal.nativeElement.click();
    }

    removeUserHierarchy(i) {
        this.purchaseOrderHierarchy.hierarchy.splice(i, 1);
        this.sortHierarchy();
    }

    openModalAddApprover() {
        this.editing = -1;
    }

    openModalEditApprover(i, user: any) {
        this.editing = i;
        this.excellenceCenterAuxId = this.purchaseOrderHierarchy.hierarchy[i].excellenceCenterId
        this.userAux = { ...user };
        this.buttonModalHierarchy.nativeElement.click();
    }

    sortHierarchy() {
        this.purchaseOrderHierarchy.hierarchy.sort((a, b) => {
            if(a.maxValue < b.maxValue) return -1;
            if(a.maxValue > b.maxValue) return 1;
            return 0;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/views/purchase-order/purchase-order-hierarchy/purchase-order-hierarchy.component.ts